import { Pipe } from '@angular/core';
import { UUID } from 'symbols';
import { MasterModel } from '../masters/states/masters/masters.model';

@Pipe({
  name: 'masterNamePipe',
  standalone: true
})
export class MasterNamePipe {
  transform(masterId: UUID, masters: MasterModel[]): string {
    const master = masters.find(m => m.id === masterId);
    return master ? `${master?.lastName} ${master?.firstName}` : '';
  }
}
